/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
// file unit test nya mana
@Injectable({
  providedIn: 'root'
})
export class PassingDataSurveyService {
  isClickLogo: Subject<any> = new Subject<any>();
  isRouteDone: Subject<any> = new Subject<any>();
  subjectLang: Subject<string> = new Subject<string>();

  watchSubjectClickLogo(): Observable<any> {
    return this.isClickLogo.asObservable();
  }

  clickLogo(isClick: boolean = false): void {
    this.isClickLogo.next(isClick);
  }

  watchSubjectRouteDone(): Observable<any> {
    return this.isRouteDone.asObservable();
  }

  clickRouteDone(isRoute: boolean = false): void {
    this.isRouteDone.next(isRoute);
  }

  watchSubjectLang(): Observable<string> {
    return this.subjectLang.asObservable();
  }

  changeLang(lang: string): void {
    this.subjectLang.next(lang);
  }
}
